<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <b-row>
        <b-col>
          <router-link v-if="prevRoute.name === 'TimetableDashboard'" :to="{ name: 'TimetableDashboard' }" class="btn btn-default float-right">
            <span v-if="!mobileView">{{$t('buttons.backToCRM')}}</span>
            <i v-else class="far fa-arrow-alt-left"></i>
          </router-link>
          <router-link v-else :to="{ name: 'EXCMUserDataStatusList' }" class="btn btn-default float-right">
            <span v-if="!mobileView">{{$t('buttons.backToList')}}</span>
            <i v-else class="far fa-arrow-alt-left"></i>
          </router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div class="card">
<!--            <div class="card-header">-->
<!--              <h4 class="card-title">{{$t('views.excmuserdatastatus.create.title')}}</h4>-->
<!--            </div>-->
            <div class="card-body">
              <b-row>
                <b-col>
                  <EXCMUserDataStatusForm
                          :handle-submit="onSendForm"
                          :handle-update-field="updateField"
                          :values="item"
                          :errors="violations" />
                </b-col>
              </b-row>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import EXCMUserDataStatusForm from './Form'
import Loader from '../../Layout/Loader'

const { mapGetters, mapActions } = createNamespacedHelpers('excmuserdatastatus/create')

export default {
  components: {
    EXCMUserDataStatusForm,
    Loader
  },
  data () {
    return {
      item: {
        color: '#ff0000',
        customOrdering: 1
      },
      prevRoute: null
    }
  },
  beforeRouteEnter (to, from, next) {
    next((vm) => {
      vm.prevRoute = from
    })
  },
  computed: {
    mobileView () {
      return this.$store.state.mobileView
    },
    ...mapGetters([
      'error',
      'isLoading',
      'created',
      'violations'
    ])
  },
  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    created: function (created) {
      if (!created) {
        return
      }
      this.$router.go(-1)
    }
  },
  methods: {
    ...mapActions([
      'create'
    ]),
    onSendForm () {
      this.item.customOrdering = parseInt(this.item.customOrdering)
      this.create(this.item)
    },
    updateField (field, value) {
      Object.assign(this.item, { [field]: value })
    }
  }
}
</script>
